module.exports = __webpack_public_path__ + "static/media/interdigitalTape.62bd3112.gif";